<template>
  <div>

    <h1 class="mb-0 text-center custom-color">
      Información de la cita
    </h1>

    <div class="d-flex justify-content-end mt-2">

      <!-- <b-button
        v-if="estadoRevision === '2'"
        variant="warning"
        @click="onRedirectEdit"
      >
        Editar cita
      </b-button> -->

      <b-button
        v-if="canViewEditButton"
        variant="warning" 
        @click="onRedirectEdit"
      >
        Editar cita
      </b-button>

    </div>

    <b-row class="mt-2">

      <b-col md="4">
        <InformacionCita :tokenCita="tokenCita"/>
      </b-col>

      <b-col md="8">

        <div
          v-if="canViewMsp"
          class="row p-2 mt-2 mb-3 mx-1" 
          style="border: 1px solid #c9c9c9"
        >
          <div class="col-12">

            <div class="row pb-1" style="border-bottom: 1px solid #c9c9c9">
              <h5 class="col-6">Documentos MSP</h5>
            </div>

            <LoadFileInput
              v-if="titulares.length > 0"
              :label="`(Pac) ${titulares[0].nombres}`"
              v-model="citaDocs.mspPaciente"
              :urlFile="urlCitaDocs.urlMspPaciente"
            />
            
            <span v-if="titulares.length > 1">
              <hr>
  
              <LoadFileInput
                :label="`(T1) ${titulares[1].nombres}`"
                v-model="citaDocs.mspTitular1"
                :urlFile="urlCitaDocs.urlMspTitular1"
              />
            </span>
            
            <span v-if="titulares.length > 2">
              <hr>
  
              <LoadFileInput
                :label="`(T2) ${titulares[2].nombres}`"
                v-model="citaDocs.mspTitular2"
                :urlFile="urlCitaDocs.urlMspTitular2"
              />
            </span>


            <span v-if="titulares.length > 3">
              <hr>
  
              <LoadFileInput
                :label="`(T3) ${titulares[3].nombres}`"
                v-model="citaDocs.mspTitular3"
                :urlFile="urlCitaDocs.urlMspTitular3"
              />
            </span>
          </div>


          <div class="col-12 d-flex justify-content-end">
            <b-button
              variant="primary"
              @click="onSaveMsp"
            >Guardar</b-button>
          </div>
        </div>

        <div
          v-if="canViewDerivacionDocs"
          class="row p-2 my-3 mx-1"
          style="border: 1px solid #c9c9c9"
        >
          <div class="col-12">
            <div class="row pb-1" style="border-bottom: 1px solid #c9c9c9">
              <h5 class="col-6">Documentos de derivación externa</h5>
            </div>

            <LoadFileInput
              label="Tirilla"
              :urlFile="urlCitaDocs.urlTirilla"
              onlyView
            />

            <hr>

            <LoadFileInput
              label="Documento Derivacion"
              :urlFile="urlCitaDocs.urlDerivacion"
              onlyView
            />

            <hr>

            <LoadFileInput
              label="Formulario 007"
              :urlFile="urlCitaDocs.urlF007"
              onlyView
            />

            <span v-if="urlCitaDocs.urlSolicitudImagen">
              <hr>

              <LoadFileInput
                label="Formulario 012"
                :urlFile="urlCitaDocs.urlSolicitudImagen"
                onlyView
              />
            </span>

            <span v-if="urlCitaDocs.urlSolicitudLaboratorio">
              <hr>

              <LoadFileInput
                label="Formulario 010"
                :urlFile="urlCitaDocs.urlSolicitudLaboratorio"
                onlyView
              />
            </span>

            <span v-if="urlCitaDocs.urlSolicitudProcedimiento">
              <hr>

              <LoadFileInput
                label="Formulario 013"
                :urlFile="urlCitaDocs.urlSolicitudProcedimiento"
                onlyView
              />
            </span>

            <span v-if="urlCitaDocs.urlOtrosDocs">
              <hr>

              <LoadFileInput
                label="Otros documentos"
                :urlFile="urlCitaDocs.urlOtrosDocs"
                onlyView
              />
            </span>
          </div>
        </div>


        <div
          v-if="canViewMsp" class="row mx-1"
        >

          <h5>Titulares</h5>

          <TitularesTable 
            :titularesList="titularesCobertura"
            onlyView
            class="col-12"
          />
        </div>


        <div v-if="canViewTipoServiciosEnviados">
          <RegistrarEnvioImagenes
            :tokenAtencion="tokenAtencion"
            :title="`Envio de imagenes`"
            onlyView
          />

          <RegistroEnvioLabsAux
            :tokenAtencion="tokenAtencion"
            :title="`Envio de laboratorios`"
            onlyView
          />


          <RegistrarEnvioProcesos
            :tokenAtencion="tokenAtencion"
            :title="`Envio de procedimientos`"
            onlyView
          />
        </div>

      </b-col>

    </b-row>

  </div>
</template>

<script>

import { mapState } from 'vuex';
import { InformacionCita } from '@/views/atencionCita/components';
import { LoadFileInput }   from '@/shared/components';
import { ROLES }           from '@/shared/constants';
import { comprobarRoles }  from '@/shared/helpers';
import { RegistrarEnvioImagenes } from '@/views/imagen/components';
import { RegistroEnvioLabsAux }   from '@/views/laboratorio/components';
import { RegistrarEnvioProcesos } from '@/views/procesoclinico/components';
import { citasService } from '../../services';
import TitularesTable  from '../TitularesTable/TitularesTable.vue';
import { saveMspCitas } from '../../helpers/saveMspCitas';

export default {
  components: {
    InformacionCita,
    LoadFileInput,
    TitularesTable,
    RegistrarEnvioImagenes,
    RegistroEnvioLabsAux,
    RegistrarEnvioProcesos
  },

  props: ['tokenCita'],

  data() {
    return {

      titulares: [],
      titularesCobertura: [],
      canViewMsp: false,
      tipoServicios: [],

      fechaCita: null,

      citaDocs:{
        mspPaciente            : null,
        mspTitular1            : null,
        mspTitular2            : null,
        mspTitular3            : null,
        tirilla                : null,
        derivacion             : null,
        solicitudImagen        : null,
        solicitudLaboratorio   : null,
        solicitudProcedimiento : null,
        f007                   : null,
        otrosDocs              : null,
      },

      urlCitaDocs:{
        urlMspPaciente            : null,
        urlMspTitular1            : null,
        urlMspTitular2            : null,
        urlMspTitular3            : null,
        urlTirilla                : null,
        urlDerivacion             : null,
        urlSolicitudImagen        : null,
        urlSolicitudLaboratorio   : null,
        urlSolicitudProcedimiento : null,
        urlF007                   : null,
        urlOtrosDocs              : null
      },

      estadoRevision: null,
      tokenAtencion: null
    }
  },

  created() {
    this.getDataCita();
    this.getTokenAtencion();
  },


  methods: {


    async getDataCita(){
      const responseCita = await citasService.getByToken(this.tokenCita);

      this.identificacionPaciente = responseCita.paciente.persona.identificacion; 

      const documentosCita = {
        urlMspPaciente            : responseCita.urlsMspPaciente,
        urlMspTitular1            : responseCita.urlsMspTitular1,
        urlMspTitular2            : responseCita.urlsMspTitular2,
        urlMspTitular3            : responseCita.urlsMspTitular3,
        urlTirilla                : responseCita.urlCodigoDer,
        urlDerivacion             : responseCita.urlDerivacion,
        urlSolicitudImagen        : responseCita.urlSolImgDer,
        urlSolicitudLaboratorio   : responseCita.urlSolLabDer,
        urlSolicitudProcedimiento : responseCita.urlSolProcDer,
        urlF007                   : responseCita.url007Recibido,
        urlOtrosDocs              : responseCita.urlOtrosDocumentos,
      }

      const dataTitularesString = responseCita.detallescitaSet[0]?.detallesTitulares;
      const dataTitulares = dataTitularesString ? JSON.parse(dataTitularesString) : [];

      // agregar el paciente 
      const dataPaciente = {
        nombres: `${responseCita.paciente.persona.identificacion} ${responseCita.paciente.persona.primerApellido} ${responseCita.paciente.persona.primerNombre}`,
      }

      this.fechaCita = responseCita?.fechaCita;

      this.tipoServicios = responseCita.tipoServicios ? JSON.parse(responseCita.tipoServicios) : [];

      this.titulares = [dataPaciente, ...dataTitulares];
      this.titularesCobertura = dataTitulares;
      this.urlCitaDocs = documentosCita;
      this.canViewMsp = responseCita.cobSeleccionada.id !== '5';
    },


    async getTokenAtencion(){
      const responseAtencion = await citasService.getAtencion(this.tokenCita);
      
      if(!responseAtencion) return;
      this.tokenAtencion = responseAtencion[0]?.token || null;
    },


    onRedirectEdit() {
      this.$router.push({
        name: 'editar_cita',
        params: { token: this.tokenCita }
      });
    },

    saveMspInState(dataFiles){

      const { mspPaciente, mspTitular1, mspTitular2, mspTitular3 } = dataFiles;
      const { urlMspPaciente, urlMspTitular1, urlMspTitular2, urlMspTitular3 } = this.urlCitaDocs;

      const docsMsp = {
        mspPaciente,
        mspTitular1,
        mspTitular2,
        mspTitular3,
        urlMspPaciente,
        urlMspTitular1,
        urlMspTitular2,
        urlMspTitular3
      }

      this.$store.commit('setDocsMspCita', docsMsp);
    },


    async onSaveMsp(){

      const confirm = await this.$swal({
        title: '¿Esta seguro de actualizar los MSP?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar'
      });

      if (!confirm.isConfirmed) return;

      const variables = await saveMspCitas(this.stDocsMsp, this.identificacionPaciente);
      if(!variables) return;

      const responseUpdateMsp = await citasService.updateByToken(this.tokenCita, variables)

      if(!responseUpdateMsp){
        await this.$swal({
          icon: 'error',
          title: 'Error al actualizar los MSP',
        })

        return;
      }

      await this.$swal({
        icon: 'success',
        title: 'MSP actualizado correctamente',
      })

      this.$router.go(0);
    }
  },


  computed: {

    ...mapState({
      stDocsMsp : state => state.citas?.verCita?.mspDocs,
    }),


    canViewTipoServiciosEnviados() {
      return ['2', '3', '4'].some(s => this.tipoServicios?.includes(s));
    },

    canViewDerivacionDocs() {
      return Boolean(
        this.urlCitaDocs.urlTirilla ||
        this.urlCitaDocs.urlDerivacion ||
        this.urlCitaDocs.urlF007 ||
        this.urlCitaDocs.urlSolicitudImagen ||
        this.urlCitaDocs.urlSolicitudLaboratorio ||
        this.urlCitaDocs.urlSolicitudProcedimiento ||
        this.urlCitaDocs.urlOtrosDocs
      );
    },


    canViewEditButton(){
      // this.estadoRevision === '2'

      return true;
    }
  },

  watch:{
    citaDocs:{
      deep:true,

      handler(newValue){
        this.saveMspInState(newValue);
      }
    }
  }

}
</script>
